.wishlistLinkStatic {
  display: flex;
  position: relative;
  flex: 0 0 auto;
  min-width: 0;
  height: 4.75rem;
  border: 0.0625rem solid var(--neutral-200);
  border-bottom-width: 0.1875rem;
  border-radius: 1rem;
  overflow: hidden;
  pointer-events: none;
  background: var(--neutral);
  box-shadow: 0.1875rem 0.3125rem 2rem -1.5rem rgba(0, 0, 0, 0.33);

  .icon {
    flex: 0 0 auto;
    order: 2;
    margin: 0 1rem 0 0.5rem;
    border-radius: 0.75rem;
    font-size: 1.25rem;
  }

  .details {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    order: 1;
    min-width: 0;
    max-width: 100%;
    margin: 0 auto 0 0;
    padding: 0 1.25rem 0 1rem;

    .name {
      max-width: 100%;
      padding: 0 0.25rem 0 0;
      font-size: 1.375rem;
      line-height: 150%;
    }

    .items {
      display: flex;
      flex: 0 0 auto;
      margin: 0 0.75rem 0 0;
      font-size: 0.875rem;
      line-height: 150%;
      font-variant-numeric: tabular-nums;
    }
  }
}
